import Vue from "vue";
import axios from "axios";

export const API_PATH = process.env.VUE_APP_API_PATH
  ? process.env.VUE_APP_API_PATH
  : "https://mybimiboo.com/api";

axios.defaults.crossDomain = true;
axios.defaults.withCredentials = true;

const service = axios.create({
  baseURL: API_PATH,
  timeout: 60 * 4 * 1000,
  headers: {
    Accept: "application/json",
  },
});

service.interceptors.request.use(
  function (config) {
    const token = Vue.$keycloak.token;
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (res) => {
    const { data, errors } = res.data;
    if (errors) {
      return Promise.reject(errors.join(", "));
    }
    return data;
  },
  (error) => {
    const errors = error?.response?.data?.errors;
    if (Array.isArray(errors)) {
      return Promise.reject(errors.join(", "));
    }
    return Promise.reject(error.message);
  }
);

export default service;
